import Formatter from './Formatter';
import Helpers from './Helpers';
import Utils from './Utils';


const formatter = new Formatter;
const helpers = new Helpers;
const utils = new Utils;

const ReportComponent = {
    formatter,

    getParams: helpers.getParams,

    utils: utils
};

export default ReportComponent;
